export default __webpack_public_path__ + "images/logoStriVectin.3413deacf11d3cad1f06f0a490b2b99b.svg"